import React from 'react'

import { TiTick } from "react-icons/ti"
import { AiOutlineAim } from "react-icons/ai"
import { IoIosArrowForward as ArrowForwardIosSharpIcon } from "react-icons/io"

import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import { Parallax } from "react-parallax";

import Ship4 from "../../../../assets/images/ship4.gif"

import "./RoadMap.scss"


let greenData = [
    {
        title: "First discussions about Sandaga",
        date: 'August 2018',
        detail: "First meetings between Hélène, Rayann and Ludovic about Sandaga. The main idea was to build a platform where artists from all over the world, regardless of their digital skills, could create, display and sell their art."
    },
    {
        title: "Birth of the Marauders",
        date: 'August 2021',
        detail: "After many weeks of brainstorming, the creative team dives into the creation of the Metaverse Marauders collection. More than 1,000 hours of drawing, inking and coloring were necessary to create the 1620 traits, 20 shapes and 16 ultra detailed backgrounds that make up the 12,000 Metaverse Marauders."
    },
    {
        title: "​​Presale on Arbitrum (ETH L2)",
        date: 'September 2021',
        detail: "First public pre-sale on Arbitrum (Ethereum Layer 2). Lightning fast transactions and very low gas fees for OG Marauders. MARAUDERS NEVER FORGET."
    },
    {
        title: "First spaceship on ETH (L1)",
        date: 'October 2021',
        detail: "A first spaceship landed on Ethereum filled with Marauders to mint. Will be followed by other spaceships."
    },

]

let purpleData = [
    {
        title: "Hiring the rest of our Team : 30 wonderful humans",
        date: 'Early 2022',
        detail: "Hiring humans : 30 people, 2 teams (the artistic team in Paris, the business team in Nevada)."
    },
    {
        title: "Sandaga : our NFT Marketplace",
        date: 'Early 2022',
        detail: "Launch of our NFT Marketplace with the ambition of becoming the n°1 NFT Marketplace in Europe, Sandaga will allow artists and collectors from all over the world to be introduced to the world of NFTs. Sandaga will be based on offering the best user experience possible in the NFT Marketplace ecosystem, therefore we will support as many blockchains as we can and tend to blockchain interoperability."
    },
    {
        title: "S.E.P. (Sandaga Education Program)",
        date: '2022',
        detail: "The Sandaga Education Program is our in-house charity program, helping creators from developing countries jumping into the NFT technology. Our Co-founder Hélène SY, will be leading the S.E.P., she already has a huge experience in charities as she is the C.E.O. of CéKeDuBonheur a very well known charity in France. We will build our first physical unit in Dakar, Senegal, with the necessary equipment and people to train local artists to the NFT technology, cryptocurrencies and business management."
    },
    {
        title: "DagaLabs",
        date: '2022',
        detail: "Launch of the first NFT collections from the DAGAlabs, our NFT studio, where we create NFTs for celebrities and brands. Already in talks with several celebrities. Metaverse Marauders holders will randomly be whitelisted to mint these high quality collections."
    },
    {
        title: "2nd Metaverse Marauders collection (Free for MM holders)",
        date: '2022',
        detail: "Metaverse Marauders owners will be able to mint a free NFT from this new exclusive collection related to the MM universe. This new collection will take the Metaverse Marauders to another level thanks to the possible interactions between the 2 collections and the upcoming PLAY 2 EARN."
    },
    {
        title: "Our $DAGA token",
        date: 'Mid-2022',
        detail: "Release of the $DAGA token. This token full of utilities related to Sandaga and the Metaverse Marauders will allow all those who joined the adventure to enjoy the crazy potential of this project. Tokenomics are coming."
    },
    {
        title: "2 BIG things for the Metaverse Marauders licence",
        date: '2022 and 2023',
        detail: "Unfortunately we cannot yet talk about it, just know that one of those will probably be something that no other NFT project has ever done, and will make the NFT ecosystem go even more mainstream (however there are some hints here and there, if you look carefully 👀 ).The other one is huge, literally. (sorry for the teasing 😅)"
    },
    {
        title: "​​All you can do in 40+ years",
        date: 'Lifetime',
        detail: "Our Team is dedicated to the project, and will make it as big as we can. We cannot wait for the coming years, and to fulfill our vision. As the Marauders say : MARAUDERS NEVER FORGET."
    },
    // {
    //     title:"sdf",
    //     date:'sdf',
    //     detail:"sd"
    // },
]

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    backgroundColor: "#1e162d",
    width: "calc(50% - 31px)",
    fontFamily: "Poppins",
    margin: '0 0 2rem 0',
    color: "white",
    border: `none`,
    padding: ".5rem",
    borderRadius: ".7rem",
    cursor: 'pointer',
    "&::hover": {
        // backgroundColor: "red"
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon color='white' size="1rem" />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));


const RoadMap = () => {
    const [expanded, setExpanded] = React.useState('');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <>
            <div className="roadmap_container">
                <div className="box">
                    <Parallax
                        renderLayer={(percentage) => {
                            let t = percentage * 1200
                            return (
                                <div className="ship4" style={{ transform: `translateX(${-t + 200}px) translateY(${t - 466}px)` }} >
                                    <img src={Ship4} alt="ERROR" />
                                </div>
                            )
                        }}
                    >
                    <div className="title"> Roadmap </div>
                    <div className="data">

                        {
                            greenData.map((data, index) => {
                                return (
                                    <>
                                        <div className="acordian_box">
                                            <div className="line">
                                                <div className="tick"> <TiTick /> </div>
                                                <p></p>
                                            </div>
                                            {/* <div className="acordian"> */}
                                            <Accordion expanded={expanded === `panel${index + 1}`} onChange={handleChange(`panel${index + 1}`)}>
                                                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                                    <div className="name">
                                                        <div className="done">
                                                            Done
                                                        </div>
                                                        <div className="detail">
                                                            <p style={{ fontWeight: "bold", fontSize: "1.2rem" }}> {data.title} </p>
                                                            <p className='date'> {data.date} </p>
                                                        </div>
                                                    </div>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Typography>
                                                        {data.detail}
                                                    </Typography>
                                                </AccordionDetails>
                                            </Accordion>
                                            {/* </div> */}
                                        </div>
                                    </>
                                )
                            })
                        }

                        {
                            purpleData.map((data, index) => {
                                return (
                                    <>
                                        <div className="acordian_box">
                                            <div className="line">
                                                <div className="tick" style={{ backgroundColor: "#5754ff" }}> <AiOutlineAim /> </div>
                                                <p style={{ backgroundColor: "#5754ff", display: purpleData.length == index + 1 ? "none" : null }}></p>
                                            </div>
                                            {/* <div className="acordian"> */}
                                            <Accordion expanded={expanded === `panel-${index + 1}`} onChange={handleChange(`panel-${index + 1}`)}>
                                                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                                    <div className="name">
                                                        <div className="done" style={{ backgroundColor: "#5754ff"}}>
                                                            Coming
                                                        </div>
                                                        <div className="detail">
                                                            <p style={{ fontWeight: "bold", fontSize: "1.2rem" }}> {data.title} </p>
                                                            <p className='date'> {data.date} </p>
                                                        </div>
                                                    </div>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Typography>
                                                        {data.detail}
                                                    </Typography>
                                                </AccordionDetails>
                                            </Accordion>
                                            {/* </div> */}
                                        </div>
                                    </>
                                )
                            })


                        }

                    </div>
                    </Parallax>
                </div>
            </div>
        </>
    )
}

export default RoadMap
